import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator'; 
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatExpansionModule } from '@angular/material/expansion';

import { LayoutModule } from '@angular/cdk/layout';

import { AuthInterceptor } from "./common/interceptors/auth.interceptor";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './navigation/components/footer/footer.component';
import { MenuListItemComponent } from './navigation/components/menu-list-item/menu-list-item.component';
import { HomeComponent } from './disbursements/components/home/home.component';
import { SideNavComponent } from './navigation/components/side-nav/side-nav.component';
import { ThemeDirective } from './common/directives/theme.directive';
import { ConfirmationDialogComponent } from './common/components/confirmation-dialog/confirmation-dialog.component';
// import { DisbursementOccurrencesComponent } from './components/disbursement-occurrences/disbursement-occurrences.component';
// import { CustomerLookupComponent } from './components/customer-lookup/customer-lookup.component';
// import { DisbursementInvitationComponent } from './components/disbursement-invitation/disbursement-invitation.component';
// import { LoginComponent } from './components/login/login.component';


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MenuListItemComponent,
    HomeComponent,
    SideNavComponent,
    ThemeDirective,
    ConfirmationDialogComponent,
    // DisbursementOccurrencesComponent,
    // CustomerLookupComponent,
    // DisbursementInvitationComponent,
    // LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule, 
    ReactiveFormsModule,
    FormsModule,

    LayoutModule,

    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatGridListModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,  
    MatRadioModule,
    MatExpansionModule,
    MatPaginatorModule, 
    MatSortModule, 
    MatDatepickerModule,
    MatNativeDateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
   }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
